import React from 'react';

import * as Separator from '@radix-ui/react-separator';

import { styled } from '@sparky/stitches';
import { TransformStitchesToSparky } from '@sparky/types';

const VerticalDividerStyled = styled(Separator.Root, {
  backgroundColor: '$borderDividerLowEmphasis',
  display: 'block',
  decorative: true,
  width: '$borderWidths$s',
});

interface Props extends TransformStitchesToSparky<typeof VerticalDividerStyled> {
  className?: never;
}

const stitchesClassName = 'sparky-divider';

export const VerticalDivider = React.forwardRef<HTMLDivElement, Props>(({ className = '' }, ref) => {
  return <VerticalDividerStyled className={`${stitchesClassName} ${className}`} ref={ref} />;
});

VerticalDivider.toString = () => `.${stitchesClassName}`;
VerticalDividerStyled.displayName = 'styled(VerticalDivider)';
VerticalDivider.displayName = 'VerticalDivider';
